
export const mapIcons = {
    startFlag: 'https://raw.githubusercontent.com/rkno1/icons/main/flags/green-flag.svg',
    endFlag: 'https://github.com/rkno1/icons/blob/main/flags/red-flag.svg',

    carGrey: 'https://raw.githubusercontent.com/rkno1/icons/main/cropped/car-crop-grey.svg',
    carGreen: 'https://raw.githubusercontent.com/rkno1/icons/main/cropped/car-crop-green.svg',
    carOrange: 'https://raw.githubusercontent.com/rkno1/icons/main/cropped/car-crop-orange.svg',
    carRed: 'https://raw.githubusercontent.com/rkno1/icons/main/cropped/car-crop-red.svg',

    pickupCarGrey: 'https://raw.githubusercontent.com/rkno1/icons/main/pickup/pickup-sm-car-grey.svg',
    pickupCarGreen: 'https://raw.githubusercontent.com/rkno1/icons/main/pickup/pickup-sm-car-green.svg',
    pickupCarOrange: 'https://raw.githubusercontent.com/rkno1/icons/main/pickup/pickup-sm-car-orange.svg',
    pickupCarRed: 'https://raw.githubusercontent.com/rkno1/icons/main/pickup/pickup-sm-car-red.svg',

    truckGrey: 'https://raw.githubusercontent.com/rkno1/icons/main/truck/truck-sm-grey.svg',
    truckGreen: 'https://raw.githubusercontent.com/rkno1/icons/main/truck/truck-sm-green.svg',
    truckOrange: 'https://raw.githubusercontent.com/rkno1/icons/main/truck/truck-sm-orange.svg',
    truckRed: 'https://raw.githubusercontent.com/rkno1/icons/main/truck/truck-sm-red.svg',

    busGrey: 'https://raw.githubusercontent.com/rkno1/icons/main/bus/bus-sm-grey.svg',
    busGreen: 'https://raw.githubusercontent.com/rkno1/icons/main/bus/bus-sm-green.svg',
    busOrange: 'https://raw.githubusercontent.com/rkno1/icons/main/bus/bus-sm-orange.svg',
    busRed: 'https://raw.githubusercontent.com/rkno1/icons/main/bus/bus-sm-red.svg',

}

import busGrey3d from '@/assets/icons/vehicles/bus-3d/grey.svg';
import busGreen3d from '@/assets/icons/vehicles/bus-3d/green.svg';
import busOrange3d from '@/assets/icons/vehicles/bus-3d/orange.svg';
import busRed3d from '@/assets/icons/vehicles/bus-3d/red.svg';
/*
import busGrey2d from'@/assets/icons/vehicles/bus-2d/bus-sm-grey.svg';
import busGreen2d from '@/assets/icons/vehicles/bus-2d/bus-sm-green.svg';
import busOrange2d from '@/assets/icons/vehicles/bus-2d/bus-sm-orange.svg';
import busRed2d from '@/assets/icons/vehicles/bus-2d/bus-sm-red.svg';

import carGrey2d from'@/assets/icons/vehicles/car-2d/car-grey-vertical.svg';
import carGreen2d from '@/assets/icons/vehicles/car-2d/car-green-vertical.svg';
import carOrange2d from '@/assets/icons/vehicles/car-2d/car-orange-vertical.svg';
import carRed2d from '@/assets/icons/vehicles/car-2d/car-red-vertical.svg';

import truckGrey2d from'@/assets/icons/vehicles/truck-2d/truck-sm-grey.svg';
import truckGreen2d from '@/assets/icons/vehicles/truck-2d/truck-sm-green.svg';
import truckOrange2d from '@/assets/icons/vehicles/truck-2d/truck-sm-orange.svg';
import truckRed2d from '@/assets/icons/vehicles/truck-2d/truck-sm-red.svg';

import bikeGrey2d from'@/assets/icons/vehicles/bike-2d/grey.svg';
import bikeGreen2d from '@/assets/icons/vehicles/bike-2d/green.svg';
import bikeOrange2d from '@/assets/icons/vehicles/bike-2d/orange.svg';
import bikeRed2d from '@/assets/icons/vehicles/bike-2d/red.svg';
*/

import bikeRedSideView from "@/assets/icons/vehicles/vehicles_sideview/bike/bike_red.svg";
import bikeGreySideView from "@/assets/icons/vehicles/vehicles_sideview/bike/bike_grey.svg";
import bikeGreenSideView from "@/assets/icons/vehicles/vehicles_sideview/bike/bike_green.svg";
import bikeOrangeSideView from "@/assets/icons/vehicles/vehicles_sideview/bike/bike_orange.svg";
import bikeBlackSideView from "@/assets/icons/vehicles/vehicles_sideview/bike/bike_black.svg";

import busRedSideView from "@/assets/icons/vehicles/vehicles_sideview/bus/bus_red.svg";
import busGreySideView from "@/assets/icons/vehicles/vehicles_sideview/bus/bus_grey.svg";
import busGreenSideView from "@/assets/icons/vehicles/vehicles_sideview/bus/bus_green.svg";
import busOrangeSideView from "@/assets/icons/vehicles/vehicles_sideview/bus/bus_orange.svg";
import busBlackSideView from "@/assets/icons/vehicles/vehicles_sideview/bus/bus_black.svg";

import carRedSideView from "@/assets/icons/vehicles/vehicles_sideview/car/car_red.svg";
import carGreySideView from "@/assets/icons/vehicles/vehicles_sideview/car/car_grey.svg";
import carGreenSideView from "@/assets/icons/vehicles/vehicles_sideview/car/car_green.svg";
import carOrangeSideView from "@/assets/icons/vehicles/vehicles_sideview/car/car_orange.svg";
import carBlackSideView from "@/assets/icons/vehicles/vehicles_sideview/car/car_black.svg";

import smallTruckRedSideView from "@/assets/icons/vehicles/vehicles_sideview/small_truck/small_truck_red.svg";
import smallTruckGreySideView from "@/assets/icons/vehicles/vehicles_sideview/small_truck/small_truck_grey.svg";
import smallTruckGreenSideView from "@/assets/icons/vehicles/vehicles_sideview/small_truck/small_truck_green.svg";
import smallTruckOrangeSideView from "@/assets/icons/vehicles/vehicles_sideview/small_truck/small_truck_orange.svg";
import smallTruckBlackSideView from "@/assets/icons/vehicles/vehicles_sideview/small_truck/small_truck_black.svg";
// import rickshawRedSideView from "@/assets/icons/vehicles/vehicles_sideview/rickShaw/rickShaw_red.svg";

import redTankerSideView from "@/assets/icons/vehicles/vehicles_sideview/tanker/tanker_red.svg";
import greyTankerSideView from "@/assets/icons/vehicles/vehicles_sideview/tanker/tanker_grey.svg";
import greenTankerSideView from "@/assets/icons/vehicles/vehicles_sideview/tanker/tanker_green.svg";
import orangeTankerSideView from "@/assets/icons/vehicles/vehicles_sideview/tanker/tanker_orange.svg";
import blackTankerSideView from "@/assets/icons/vehicles/vehicles_sideview/tanker/tanker_black.svg";

import stoppedTravellerSideView from "@/assets/icons/vehicles/vehicles_sideview/traveller/traveller-stopped.svg";
import activeTravellerSideView from "@/assets/icons/vehicles/vehicles_sideview/traveller/traveller-active.svg";
import idleTravellerSideView from "@/assets/icons/vehicles/vehicles_sideview/traveller/traveller-idle.svg";
import inactiveTravellerSideView from "@/assets/icons/vehicles/vehicles_sideview/traveller/traveller-inactive.svg";
import nosignalTravellerSideView from "@/assets/icons/vehicles/vehicles_sideview/traveller/traveller-nosignal.svg";

import busInclinedActive from '@/assets/icons/vehicles/vehicles_inclined_view/bus_active.svg';
import busInclinedInactive from '@/assets/icons/vehicles/vehicles_inclined_view/bus_inactive.svg';
import busInclinedStopped from '@/assets/icons/vehicles/vehicles_inclined_view/bus_stopped.svg';
import busInclinedIdle from '@/assets/icons/vehicles/vehicles_inclined_view/bus_idle.svg';
import busInclinedNoSignal from '@/assets/icons/vehicles/vehicles_inclined_view/bus_nosignal.svg';


import carInclinedActive from '@/assets/icons/vehicles/vehicles_inclined_view/car_active.svg';
import carInclinedInactive from '@/assets/icons/vehicles/vehicles_inclined_view/car_inactive.svg';
import carInclinedStopped from '@/assets/icons/vehicles/vehicles_inclined_view/car_stopped.svg';
import carInclinedIdle from '@/assets/icons/vehicles/vehicles_inclined_view/car_idle.svg';
import carInclinedNoSignal from '@/assets/icons/vehicles/vehicles_inclined_view/car_nosignal.svg';

import truckInclinedActive from '@/assets/icons/vehicles/vehicles_inclined_view/truck_active.svg';
import truckInclinedInactive from '@/assets/icons/vehicles/vehicles_inclined_view/truck_inactive.svg';
import truckInclinedStopped from '@/assets/icons/vehicles/vehicles_inclined_view/truck_stopped.svg';
import truckInclinedIdle from '@/assets/icons/vehicles/vehicles_inclined_view/truck_idle.svg';
import truckInclinedNoSignal from '@/assets/icons/vehicles/vehicles_inclined_view/truck_nosignal.svg';

import bikeInclinedActive from '@/assets/icons/vehicles/vehicles_inclined_view/bike_active.svg';
import bikeInclinedInactive from '@/assets/icons/vehicles/vehicles_inclined_view/bike_inactive.svg';
import bikeInclinedStopped from '@/assets/icons/vehicles/vehicles_inclined_view/bike_stopped.svg';
import bikeInclinedIdle from '@/assets/icons/vehicles/vehicles_inclined_view/bike_idle.svg';
import bikeInclinedNoSignal from '@/assets/icons/vehicles/vehicles_inclined_view/bike_nosignal.svg';

import tankerInclinedActive from '@/assets/icons/vehicles/vehicles_inclined_view/tanker_active.svg';
import tankerInclinedInactive from '@/assets/icons/vehicles/vehicles_inclined_view/tanker_inactive.svg';
import tankerInclinedStopped from '@/assets/icons/vehicles/vehicles_inclined_view/tanker_stopped.svg';
import tankerInclinedIdle from '@/assets/icons/vehicles/vehicles_inclined_view/tanker_idle.svg';
import tankerInclinedNoSignal from '@/assets/icons/vehicles/vehicles_inclined_view/tanker_nosignal.svg';

import travellerInclinedActive from '@/assets/icons/vehicles/vehicles_inclined_view/traveller_active.svg';
import travellerInclinedInactive from '@/assets/icons/vehicles/vehicles_inclined_view/traveller_inactive.svg';
import travellerInclinedStopped from '@/assets/icons/vehicles/vehicles_inclined_view/traveller_stopped.svg';
import travellerInclinedIdle from '@/assets/icons/vehicles/vehicles_inclined_view/traveller_idle.svg';
// import tankerInclinedNoSignal from '@/assets/icons/vehicles/vehicles_inclined_view/traveller_nosignal.svg';

// Menu Icons
import moreDetailsSVG from "@/assets/icons/menu/moredetails.svg";
import searchSVG from "@/assets/icons/menu/search.svg";
import morePng from "@/assets/icons/menu/more_icon.png";

// Geofence Icons
import geofenceBlueSVG from "@/assets/icons/geofence-icons/geofence-blue.svg";
import geofenceWhitePinSVG from "@/assets/icons/geofence-icons/geofence-white-pin.svg";
import allFenceSVG from "@/assets/icons/geofence-icons/all-fence.svg";
import greenSquareSVG from "@/assets/icons/geofence-icons/green-square.svg";
import redSquareSVG from "@/assets/icons/geofence-icons/red-square.svg";
import greenCarAdd from "@/assets/icons/geofence-icons/green-car-add.svg";
import redCarRemove from "@/assets/icons/geofence-icons/red-car-remove.svg";
import bubblesSVG from "@/assets/icons/geofence-icons/bubbles.svg";

//DashboardIcons 
import carRunningDB from "@/assets/icons/dashboard-icons/fleet/car-running.svg";
import carIdleDB from "@/assets/icons/dashboard-icons/fleet/car-idle.svg";
import carInactiveDB from "@/assets/icons/dashboard-icons/fleet/car-inactive.svg";
import carStoppedDB from "@/assets/icons/dashboard-icons/fleet/car-stopped.svg";
import carNosignalDB from "@/assets/icons/dashboard-icons/fleet/car-nosignal.svg";

export const MENU_ICONS = {
    moreDetailsSVG,
    searchSVG,
    morePng,
}

export const GEOFENCE_ICONS = {
    geofenceBlueSVG,
    geofenceWhitePinSVG,
    allFenceSVG,
    greenSquareSVG,
    redSquareSVG,
    greenCarAdd,
    redCarRemove,
    bubblesSVG,
}

export const vehicleIcons = {
    busGrey3d,
    busGreen3d,
    busOrange3d,
    busRed3d,

    /*
    busGrey2d,
    busGreen2d,
    busOrange2d,
    busRed2d,

    carGrey2d,
    carGreen2d,
    carOrange2d,
    carRed2d,

    truckGrey2d,
    truckGreen2d,
    truckOrange2d,
    truckRed2d,

    bikeGrey2d,
    bikeGreen2d,
    bikeOrange2d,
    bikeRed2d,
    */
}

export const DASHBOARD_ICONS = {
    RUNNING: carRunningDB,
    IDLE: carIdleDB,
    INACTIVE: carInactiveDB,
    STOPPED: carStoppedDB,
    NO_SIGNAL: carNosignalDB,
}

import { VEHICLE_STATUS, VEHICLE_TYPE } from "./map/mapUtils";

export const CAR_ICONS_SIDEVIEW = {
    [VEHICLE_STATUS.ACTIVE]: carGreenSideView,
    [VEHICLE_STATUS.INATCTIVE]: carGreySideView,
    [VEHICLE_STATUS.IDLE]: carOrangeSideView,
    [VEHICLE_STATUS.STOPPED]: carRedSideView,
    [VEHICLE_STATUS.NO_SIGNAL]: carBlackSideView,
}
export const SMALL_TRUCK_ICONS_SIDEVIEW = {
    [VEHICLE_STATUS.ACTIVE]: smallTruckGreenSideView,
    [VEHICLE_STATUS.INATCTIVE]: smallTruckGreySideView,
    [VEHICLE_STATUS.IDLE]: smallTruckOrangeSideView,
    [VEHICLE_STATUS.STOPPED]: smallTruckRedSideView,
    [VEHICLE_STATUS.NO_SIGNAL]: smallTruckBlackSideView,
}
export const BUS_ICONS_SIDEVIEW = {
    [VEHICLE_STATUS.ACTIVE]: busGreenSideView,
    [VEHICLE_STATUS.INATCTIVE]: busGreySideView,
    [VEHICLE_STATUS.IDLE]: busOrangeSideView,
    [VEHICLE_STATUS.STOPPED]: busRedSideView,
    [VEHICLE_STATUS.NO_SIGNAL]: busBlackSideView,
}
export const BIKE_ICONS_SIDEVIEW = {
    [VEHICLE_STATUS.ACTIVE]: bikeGreenSideView,
    [VEHICLE_STATUS.INATCTIVE]: bikeGreySideView,
    [VEHICLE_STATUS.IDLE]: bikeOrangeSideView,
    [VEHICLE_STATUS.STOPPED]: bikeRedSideView,
    [VEHICLE_STATUS.NO_SIGNAL]: bikeBlackSideView,
}
export const TANKER_ICONS_SIDEVIEW = {
    [VEHICLE_STATUS.ACTIVE]: greenTankerSideView,
    [VEHICLE_STATUS.INATCTIVE]: greyTankerSideView,
    [VEHICLE_STATUS.IDLE]: orangeTankerSideView,
    [VEHICLE_STATUS.STOPPED]: redTankerSideView,
    [VEHICLE_STATUS.NO_SIGNAL]: blackTankerSideView
}
export const TRAVELLER_ICONS_SIDEVIEW = {
    [VEHICLE_STATUS.ACTIVE]: activeTravellerSideView,
    [VEHICLE_STATUS.INATCTIVE]: inactiveTravellerSideView,
    [VEHICLE_STATUS.IDLE]: idleTravellerSideView,
    [VEHICLE_STATUS.STOPPED]: stoppedTravellerSideView,
    [VEHICLE_STATUS.NO_SIGNAL]: nosignalTravellerSideView
}

export const VEHICLE_SIDEVIEW = {
    [VEHICLE_TYPE.CAR]: CAR_ICONS_SIDEVIEW,
    [VEHICLE_TYPE.BIKE]: BIKE_ICONS_SIDEVIEW,
    [VEHICLE_TYPE.BUS]: BUS_ICONS_SIDEVIEW,
    [VEHICLE_TYPE.TRUCK]: SMALL_TRUCK_ICONS_SIDEVIEW,
    [VEHICLE_TYPE.TRAVELLER]: TRAVELLER_ICONS_SIDEVIEW,
    [VEHICLE_TYPE.TANKER]: TANKER_ICONS_SIDEVIEW,
}


export const CAR_ICONS_INCLINED_VIEW = {
    [VEHICLE_STATUS.ACTIVE]: carInclinedActive,
    [VEHICLE_STATUS.INATCTIVE]: carInclinedInactive,
    [VEHICLE_STATUS.IDLE]: carInclinedIdle,
    [VEHICLE_STATUS.STOPPED]: carInclinedStopped,
    [VEHICLE_STATUS.NO_SIGNAL]: carInclinedNoSignal,
}
export const SMALL_TRUCK_ICONS_INCLINED_VIEW = {
    [VEHICLE_STATUS.ACTIVE]: truckInclinedActive,
    [VEHICLE_STATUS.INATCTIVE]: truckInclinedInactive,
    [VEHICLE_STATUS.IDLE]: truckInclinedIdle,
    [VEHICLE_STATUS.STOPPED]: truckInclinedStopped,
    [VEHICLE_STATUS.NO_SIGNAL]: truckInclinedNoSignal,
}
export const BUS_ICONS_INCLINED_VIEW = {
    [VEHICLE_STATUS.ACTIVE]: busInclinedActive,
    [VEHICLE_STATUS.INATCTIVE]: busInclinedInactive,
    [VEHICLE_STATUS.IDLE]: busInclinedIdle,
    [VEHICLE_STATUS.STOPPED]: busInclinedStopped,
    [VEHICLE_STATUS.NO_SIGNAL]: busInclinedNoSignal,
}
export const BIKE_ICONS_INCLINED_VIEW = {
    [VEHICLE_STATUS.ACTIVE]: bikeInclinedActive,
    [VEHICLE_STATUS.INATCTIVE]: bikeInclinedInactive,
    [VEHICLE_STATUS.IDLE]: bikeInclinedIdle,
    [VEHICLE_STATUS.STOPPED]: bikeInclinedStopped,
    [VEHICLE_STATUS.NO_SIGNAL]: bikeInclinedNoSignal,
}
export const TANKER_ICONS_INCLINED_VIEW = {
    [VEHICLE_STATUS.ACTIVE]: tankerInclinedActive,
    [VEHICLE_STATUS.INATCTIVE]: tankerInclinedInactive,
    [VEHICLE_STATUS.IDLE]: tankerInclinedIdle,
    [VEHICLE_STATUS.STOPPED]: tankerInclinedStopped,
    [VEHICLE_STATUS.NO_SIGNAL]: tankerInclinedNoSignal,
}
export const TRAVELLER_ICONS_INCLINED_VIEW = {
    [VEHICLE_STATUS.ACTIVE]: travellerInclinedActive,
    [VEHICLE_STATUS.INATCTIVE]: travellerInclinedInactive,
    [VEHICLE_STATUS.IDLE]: travellerInclinedIdle,
    [VEHICLE_STATUS.STOPPED]: travellerInclinedStopped,
    // [VEHICLE_STATUS.NO_SIGNAL]: travellerInclinedNoSignal,
}


export const VEHICLE_INCLINED_VIEW = {
    [VEHICLE_TYPE.CAR]: CAR_ICONS_INCLINED_VIEW,
    [VEHICLE_TYPE.BIKE]: BIKE_ICONS_INCLINED_VIEW,
    [VEHICLE_TYPE.BUS]: BUS_ICONS_INCLINED_VIEW,
    [VEHICLE_TYPE.TRUCK]: SMALL_TRUCK_ICONS_INCLINED_VIEW,
    [VEHICLE_TYPE.TRAVELLER]: TRAVELLER_ICONS_INCLINED_VIEW,
    [VEHICLE_TYPE.TANKER]: TANKER_ICONS_INCLINED_VIEW,
}

export const getVehiclesSideView = (vehicleType = VEHICLE_TYPE.CAR, status = VEHICLE_STATUS.STOPPED) => VEHICLE_SIDEVIEW[vehicleType] && VEHICLE_SIDEVIEW[vehicleType][status] ? VEHICLE_SIDEVIEW[vehicleType][status] : VEHICLE_SIDEVIEW[VEHICLE_TYPE.CAR][VEHICLE_STATUS.INACTIVE];

export const getVehiclesInclinedView = (vehicleType = VEHICLE_TYPE.CAR, status = VEHICLE_STATUS.STOPPED) => VEHICLE_INCLINED_VIEW[vehicleType] && VEHICLE_INCLINED_VIEW[vehicleType][status] ? VEHICLE_INCLINED_VIEW[vehicleType][status] : VEHICLE_INCLINED_VIEW[VEHICLE_TYPE.CAR][VEHICLE_STATUS.INACTIVE];
